module.exports = __webpack_public_path__ + "img/logo.4f5bc2a2.webp";